import React, { createContext, useContext, useState, useEffect } from 'react';

// Language Context
const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

// Comprehensive Translations for entire app
const translations = {
  // Navigation
  'dashboard': { en: 'Dashboard', hi: 'डैशबोर्ड' },
  'schools': { en: 'Schools', hi: 'विद्यालय' },
  'classes': { en: 'Classes', hi: 'कक्षाएं' },
  'students': { en: 'Students', hi: 'विद्यार्थी' },
  'teachers': { en: 'Teachers', hi: 'शिक्षक' },
  'attendance': { en: 'Attendance', hi: 'उपस्थिति' },
  'exams': { en: 'Exams & Results', hi: 'परीक्षा व परिणाम' },
  'timetable': { en: 'Timetable', hi: 'समय सारणी' },
  'calendar': { en: 'Calendar', hi: 'कैलेंडर' },
  'fees': { en: 'Fees', hi: 'शुल्क' },
  'communication': { en: 'Communication', hi: 'संचार' },
  'whatsapp': { en: 'WhatsApp', hi: 'व्हाट्सएप' },
  'complaints': { en: 'Complaints', hi: 'शिकायतें' },
  'reports': { en: 'Reports', hi: 'रिपोर्ट' },
  'bulk_import': { en: 'Bulk Import', hi: 'बल्क आयात' },
  'ai_features': { en: 'AI Features', hi: 'AI सुविधाएं' },
  'settings': { en: 'Settings', hi: 'सेटिंग्स' },
  
  // Common Actions
  'login': { en: 'Login', hi: 'लॉगिन' },
  'logout': { en: 'Logout', hi: 'लॉगआउट' },
  'save': { en: 'Save', hi: 'सहेजें' },
  'cancel': { en: 'Cancel', hi: 'रद्द करें' },
  'submit': { en: 'Submit', hi: 'जमा करें' },
  'search': { en: 'Search', hi: 'खोजें' },
  'add': { en: 'Add', hi: 'जोड़ें' },
  'edit': { en: 'Edit', hi: 'संपादित करें' },
  'delete': { en: 'Delete', hi: 'हटाएं' },
  'view': { en: 'View', hi: 'देखें' },
  'print': { en: 'Print', hi: 'प्रिंट' },
  'download': { en: 'Download', hi: 'डाउनलोड' },
  'export': { en: 'Export', hi: 'निर्यात' },
  'loading': { en: 'Loading...', hi: 'लोड हो रहा है...' },
  'no_data': { en: 'No data found', hi: 'कोई डेटा नहीं मिला' },
  'success': { en: 'Success', hi: 'सफल' },
  'error': { en: 'Error', hi: 'त्रुटि' },
  'confirm': { en: 'Confirm', hi: 'पुष्टि करें' },
  'yes': { en: 'Yes', hi: 'हां' },
  'no': { en: 'No', hi: 'नहीं' },
  'all': { en: 'All', hi: 'सभी' },
  'total': { en: 'Total', hi: 'कुल' },
  'status': { en: 'Status', hi: 'स्थिति' },
  'active': { en: 'Active', hi: 'सक्रिय' },
  'inactive': { en: 'Inactive', hi: 'निष्क्रिय' },
  'name': { en: 'Name', hi: 'नाम' },
  'phone': { en: 'Phone', hi: 'फ़ोन' },
  'email': { en: 'Email', hi: 'ईमेल' },
  'address': { en: 'Address', hi: 'पता' },
  'date': { en: 'Date', hi: 'तारीख' },
  'time': { en: 'Time', hi: 'समय' },
  'actions': { en: 'Actions', hi: 'कार्रवाई' },
  'refresh': { en: 'Refresh', hi: 'रिफ्रेश' },
  'back': { en: 'Back', hi: 'वापस' },
  'next': { en: 'Next', hi: 'अगला' },
  'previous': { en: 'Previous', hi: 'पिछला' },
  'close': { en: 'Close', hi: 'बंद करें' },
  'select': { en: 'Select', hi: 'चुनें' },
  'required': { en: 'Required', hi: 'आवश्यक' },
  'optional': { en: 'Optional', hi: 'वैकल्पिक' },
  
  // Student related
  'admission_number': { en: 'Admission No.', hi: 'प्रवेश क्रमांक' },
  'roll_number': { en: 'Roll No.', hi: 'रोल नंबर' },
  'class': { en: 'Class', hi: 'कक्षा' },
  'section': { en: 'Section', hi: 'सेक्शन' },
  'gender': { en: 'Gender', hi: 'लिंग' },
  'male': { en: 'Male', hi: 'पुरुष' },
  'female': { en: 'Female', hi: 'महिला' },
  'other': { en: 'Other', hi: 'अन्य' },
  'dob': { en: 'Date of Birth', hi: 'जन्म तिथि' },
  'father_name': { en: "Father's Name", hi: 'पिता का नाम' },
  'mother_name': { en: "Mother's Name", hi: 'माता का नाम' },
  'guardian': { en: 'Guardian', hi: 'अभिभावक' },
  'category': { en: 'Category', hi: 'श्रेणी' },
  'add_student': { en: 'Add Student', hi: 'विद्यार्थी जोड़ें' },
  'new_student': { en: 'New Student', hi: 'नया विद्यार्थी' },
  'student_list': { en: 'Student List', hi: 'विद्यार्थी सूची' },
  'student_details': { en: 'Student Details', hi: 'विद्यार्थी विवरण' },
  
  // Fee related
  'fee_amount': { en: 'Fee Amount', hi: 'शुल्क राशि' },
  'due_date': { en: 'Due Date', hi: 'देय तिथि' },
  'paid': { en: 'Paid', hi: 'भुगतान किया' },
  'pending': { en: 'Pending', hi: 'बकाया' },
  'overdue': { en: 'Overdue', hi: 'अतिदेय' },
  'collect_fee': { en: 'Collect Fee', hi: 'शुल्क लें' },
  'fee_plan': { en: 'Fee Plan', hi: 'शुल्क योजना' },
  
  // Attendance
  'present': { en: 'Present', hi: 'उपस्थित' },
  'absent': { en: 'Absent', hi: 'अनुपस्थित' },
  'late': { en: 'Late', hi: 'विलंब' },
  'leave': { en: 'Leave', hi: 'छुट्टी' },
  'mark_attendance': { en: 'Mark Attendance', hi: 'उपस्थिति लगाएं' },
  'today_attendance': { en: "Today's Attendance", hi: 'आज की उपस्थिति' },
  
  // Dashboard
  'welcome': { en: 'Welcome', hi: 'स्वागत है' },
  'school_management': { en: 'School Management Platform', hi: 'स्कूल प्रबंधन प्लेटफ़ॉर्म' },
  'total_students': { en: 'Total Students', hi: 'कुल विद्यार्थी' },
  'total_teachers': { en: 'Total Teachers', hi: 'कुल शिक्षक' },
  'monthly_collection': { en: 'Monthly Collection', hi: 'मासिक संग्रह' },
  'quick_overview': { en: 'Quick Overview', hi: 'त्वरित अवलोकन' },
  'recent_activity': { en: 'Recent Activity', hi: 'हाल की गतिविधि' },
  'students_by_gender': { en: 'Students by Gender', hi: 'लिंग अनुसार विद्यार्थी' },
  'attendance_trend': { en: 'Attendance Trend', hi: 'उपस्थिति प्रवृत्ति' },
  'fee_collection': { en: 'Fee Collection', hi: 'शुल्क संग्रह' },
  'students_per_class': { en: 'Students per Class', hi: 'कक्षा अनुसार विद्यार्थी' },
  
  // Messages
  'student_added': { en: 'Student added successfully', hi: 'विद्यार्थी सफलतापूर्वक जोड़ा गया' },
  'student_updated': { en: 'Student updated successfully', hi: 'विद्यार्थी अपडेट हो गया' },
  'attendance_saved': { en: 'Attendance saved', hi: 'उपस्थिति सहेजी गई' },
  'connection_error': { en: 'Connection error', hi: 'कनेक्शन त्रुटि' },
  
  // Login page
  'login_title': { en: 'Login', hi: 'लॉगिन करें' },
  'phone_number': { en: 'Phone Number', hi: 'फ़ोन नंबर' },
  'password': { en: 'Password', hi: 'पासवर्ड' },
  'otp_login': { en: 'OTP Login', hi: 'OTP से लॉगिन' },
  'send_otp': { en: 'Send OTP', hi: 'OTP भेजें' },
  'verify_otp': { en: 'Verify OTP', hi: 'OTP सत्यापित करें' },
  'demo_credentials': { en: 'Demo Credentials', hi: 'डेमो क्रेडेंशियल्स' },
  
  // Roles
  'platform_admin': { en: 'Platform Admin', hi: 'प्लेटफ़ॉर्म एडमिन' },
  'school_admin': { en: 'School Admin', hi: 'स्कूल एडमिन' },
  'teacher': { en: 'Teacher', hi: 'शिक्षक' },
  'parent': { en: 'Parent', hi: 'अभिभावक' },
  'student': { en: 'Student', hi: 'विद्यार्थी' },
  
  // AI Features Page
  'ai_features_title': { en: 'AI Features', hi: 'AI सुविधाएं' },
  'ai_powered_by': { en: 'Powered by GPT-5.2', hi: 'GPT-5.2 द्वारा संचालित' },
  'select_feature': { en: 'Select a feature', hi: 'कोई सुविधा चुनें' },
  'generate': { en: 'Generate', hi: 'बनाएं' },
  'result': { en: 'Result', hi: 'परिणाम' },
  'copy_result': { en: 'Copy Result', hi: 'परिणाम कॉपी करें' },
  'try_again': { en: 'Try Again', hi: 'फिर से करें' },
  'view_details': { en: 'View Details', hi: 'विवरण देखें' },
  'how_it_works': { en: 'How it works', hi: 'यह कैसे काम करता है' },
  'benefits': { en: 'Benefits', hi: 'लाभ' },
  'limitations': { en: 'Limitations', hi: 'सीमाएं' },
  'use_cases': { en: 'Use Cases', hi: 'उपयोग के उदाहरण' },
  
  // Communication
  'announcement': { en: 'Announcement', hi: 'घोषणा' },
  'notice': { en: 'Notice', hi: 'नोटिस' },
  'homework': { en: 'Homework', hi: 'गृहकार्य' },
  'event': { en: 'Event', hi: 'कार्यक्रम' },
  'holiday': { en: 'Holiday', hi: 'छुट्टी' },
  
  // Form tabs
  'basic_info': { en: 'Basic Info', hi: 'मूल जानकारी' },
  'identity_category': { en: 'Identity & Category', hi: 'पहचान व श्रेणी' },
  'academic': { en: 'Academic', hi: 'शैक्षणिक' },
  'parents_guardian': { en: 'Parents/Guardian', hi: 'अभिभावक' },
  'contact_address': { en: 'Contact & Address', hi: 'संपर्क व पता' },
  'bank_facilities': { en: 'Bank & Facilities', hi: 'बैंक व सुविधाएं' },
  'documents': { en: 'Documents', hi: 'दस्तावेज़' },
  
  // Legal pages
  'privacy_policy': { en: 'Privacy Policy', hi: 'गोपनीयता नीति' },
  'terms_conditions': { en: 'Terms & Conditions', hi: 'नियम और शर्तें' },
  'refund_policy': { en: 'Refund Policy', hi: 'वापसी नीति' },
  'contact_us': { en: 'Contact Us', hi: 'संपर्क करें' },
  'about_us': { en: 'About Us', hi: 'हमारे बारे में' },
};

// English to Hindi character mapping for transliteration
const translitMap = {
  // Vowels
  'a': 'अ', 'aa': 'आ', 'i': 'इ', 'ee': 'ई', 'u': 'उ', 'oo': 'ऊ',
  'e': 'ए', 'ai': 'ऐ', 'o': 'ओ', 'au': 'औ', 'am': 'अं', 'ah': 'अः',
  
  // Consonants
  'ka': 'का', 'kha': 'खा', 'ga': 'गा', 'gha': 'घा', 'nga': 'ङा',
  'cha': 'चा', 'chha': 'छा', 'ja': 'जा', 'jha': 'झा', 'nya': 'ञा',
  'ta': 'टा', 'tha': 'ठा', 'da': 'डा', 'dha': 'ढा', 'na': 'णा',
  'ta': 'ता', 'tha': 'था', 'da': 'दा', 'dha': 'धा', 'na': 'ना',
  'pa': 'पा', 'pha': 'फा', 'ba': 'बा', 'bha': 'भा', 'ma': 'मा',
  'ya': 'या', 'ra': 'रा', 'la': 'ला', 'va': 'वा', 'wa': 'वा',
  'sha': 'शा', 'sa': 'सा', 'ha': 'हा',
  'ksha': 'क्षा', 'tra': 'त्रा', 'gya': 'ज्ञा',
  
  // Half consonants (without matra)
  'k': 'क', 'kh': 'ख', 'g': 'ग', 'gh': 'घ',
  'ch': 'च', 'chh': 'छ', 'j': 'ज', 'jh': 'झ',
  't': 'त', 'th': 'थ', 'd': 'द', 'dh': 'ध', 'n': 'न',
  'p': 'प', 'ph': 'फ', 'b': 'ब', 'bh': 'भ', 'm': 'म',
  'y': 'य', 'r': 'र', 'l': 'ल', 'v': 'व', 'w': 'व',
  'sh': 'श', 's': 'स', 'h': 'ह',
  
  // Common Indian names (comprehensive list)
  'rahul': 'राहुल', 'amit': 'अमित', 'priya': 'प्रिया', 'neha': 'नेहा',
  'raj': 'राज', 'ravi': 'रवि', 'suman': 'सुमन', 'anita': 'अनीता',
  'kumar': 'कुमार', 'sharma': 'शर्मा', 'singh': 'सिंह', 'verma': 'वर्मा',
  'gupta': 'गुप्ता', 'patel': 'पटेल', 'mishra': 'मिश्रा', 'pandey': 'पांडे',
  'anil': 'अनिल', 'sunil': 'सुनील', 'ramesh': 'रमेश', 'suresh': 'सुरेश',
  'deepak': 'दीपक', 'vijay': 'विजय', 'ajay': 'अजय', 'sanjay': 'संजय',
  'pooja': 'पूजा', 'ritu': 'रितु', 'geeta': 'गीता', 'seema': 'सीमा',
  'mohan': 'मोहन', 'sohan': 'सोहन', 'gopal': 'गोपाल', 'krishna': 'कृष्णा',
  'shyam': 'श्याम', 'ram': 'राम', 'lakshman': 'लक्ष्मण', 'bharat': 'भरत',
  'arjun': 'अर्जुन', 'karan': 'करण', 'rohan': 'रोहन', 'aman': 'अमन',
  'vikas': 'विकास', 'prakash': 'प्रकाश', 'dinesh': 'दिनेश', 'mukesh': 'मुकेश',
  'rakesh': 'राकेश', 'mahesh': 'महेश', 'naresh': 'नरेश', 'ganesh': 'गणेश',
  'ashok': 'अशोक', 'alok': 'आलोक', 'vivek': 'विवेक', 'abhishek': 'अभिषेक',
  'manish': 'मनीष', 'satish': 'सतीश', 'girish': 'गिरीश', 'rajesh': 'राजेश',
  'sunita': 'सुनीता', 'kavita': 'कविता', 'savita': 'सविता', 'mamta': 'ममता',
  'rekha': 'रेखा', 'shikha': 'शिखा', 'nisha': 'निशा', 'usha': 'उषा',
  'meena': 'मीना', 'reena': 'रीना', 'sheena': 'शीना', 'tina': 'टीना',
  'asha': 'आशा', 'disha': 'दिशा', 'riya': 'रिया', 'diya': 'दिया',
  'aryan': 'आर्यन', 'ayush': 'आयुष', 'harsh': 'हर्ष', 'dev': 'देव',
  'yash': 'यश', 'om': 'ॐ', 'arun': 'अरुण', 'varun': 'वरुण',
  'mohit': 'मोहित', 'rohit': 'रोहित', 'sumit': 'सुमित', 'ankit': 'अंकित',
  'nikhil': 'निखिल', 'akhil': 'अखिल', 'sahil': 'साहिल', 'kunal': 'कुनाल',
  'vishal': 'विशाल', 'kushal': 'कुशल', 'sagar': 'सागर', 'gaurav': 'गौरव',
  'sourav': 'सौरव', 'anurag': 'अनुराग', 'chirag': 'चिराग', 'neeraj': 'नीरज',
  
  // Surnames
  'tiwari': 'तिवारी', 'dwivedi': 'द्विवेदी', 'tripathi': 'त्रिपाठी', 'chaturvedi': 'चतुर्वेदी',
  'shukla': 'शुक्ला', 'pathak': 'पाठक', 'upadhyay': 'उपाध्याय', 'joshi': 'जोशी',
  'thakur': 'ठाकुर', 'rajput': 'राजपूत', 'chauhan': 'चौहान', 'rathore': 'राठौर',
  'yadav': 'यादव', 'ahirwar': 'अहिरवार', 'lodhi': 'लोधी', 'kori': 'कोरी',
  'sahu': 'साहू', 'kewat': 'केवट', 'malviya': 'मालवीय', 'solanki': 'सोलंकी',
};

// Advanced transliteration function using phonetic rules
export const transliterateToHindi = (englishText) => {
  if (!englishText) return '';
  
  const words = englishText.toLowerCase().trim().split(/\s+/);
  const hindiWords = words.map(word => {
    // First check if the exact word exists in our dictionary
    if (translitMap[word]) {
      return translitMap[word];
    }
    
    // Try phonetic transliteration
    let hindi = '';
    let i = 0;
    while (i < word.length) {
      let matched = false;
      // Try longest match first (up to 4 chars)
      for (let len = Math.min(4, word.length - i); len >= 1; len--) {
        const substr = word.substring(i, i + len);
        if (translitMap[substr]) {
          hindi += translitMap[substr];
          i += len;
          matched = true;
          break;
        }
      }
      if (!matched) {
        hindi += word[i];
        i++;
      }
    }
    return hindi || word;
  });
  
  return hindiWords.join(' ');
};

// Language Provider Component
export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('shiksha_mitra_lang') || 'en';
  });

  useEffect(() => {
    localStorage.setItem('shiksha_mitra_lang', language);
    document.documentElement.lang = language;
  }, [language]);

  // Translation function - returns translated text or key if not found
  const t = (key) => {
    if (translations[key]) {
      return translations[key][language] || translations[key]['en'] || key;
    }
    return key;
  };

  // Toggle between Hindi and English
  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'hi' : 'en');
  };

  // Check if current language is Hindi
  const isHindi = language === 'hi';

  return (
    <LanguageContext.Provider value={{ 
      language, 
      setLanguage, 
      toggleLanguage, 
      t, 
      transliterateToHindi,
      isHindi 
    }}>
      {children}
    </LanguageContext.Provider>
  );
}

// Language Toggle Button Component - Enhanced UI
export function LanguageToggle({ className = '' }) {
  const { language, toggleLanguage } = useLanguage();
  
  return (
    <button
      onClick={toggleLanguage}
      className={`flex items-center gap-2 px-3 py-1.5 bg-white/10 hover:bg-white/20 rounded-full text-sm font-medium transition-all duration-300 ${className}`}
      data-testid="language-toggle"
      aria-label={`Switch to ${language === 'en' ? 'Hindi' : 'English'}`}
    >
      <span className={`transition-opacity ${language === 'en' ? 'opacity-100 font-bold' : 'opacity-60'}`}>EN</span>
      <div className={`w-10 h-5 rounded-full relative transition-colors duration-300 ${language === 'hi' ? 'bg-orange-400' : 'bg-gray-400'}`}>
        <div className={`absolute w-4 h-4 bg-white rounded-full top-0.5 transition-all duration-300 shadow-sm ${language === 'hi' ? 'right-0.5' : 'left-0.5'}`} />
      </div>
      <span className={`transition-opacity ${language === 'hi' ? 'opacity-100 font-bold' : 'opacity-60'}`}>हिं</span>
    </button>
  );
}

// Compact Language Toggle for mobile
export function LanguageToggleCompact({ className = '' }) {
  const { language, toggleLanguage } = useLanguage();
  
  return (
    <button
      onClick={toggleLanguage}
      className={`flex items-center justify-center w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 transition-all ${className}`}
      data-testid="language-toggle-compact"
      aria-label={`Switch to ${language === 'en' ? 'Hindi' : 'English'}`}
    >
      <span className="font-bold text-sm">{language === 'en' ? 'हिं' : 'EN'}</span>
    </button>
  );
}

// Auto Hindi Name Input Component - For forms
export function AutoHindiNameInput({ 
  englishValue, 
  hindiValue, 
  onEnglishChange, 
  onHindiChange, 
  placeholder, 
  label, 
  required,
  englishPlaceholder = "Type name in English...",
  hindiPlaceholder = "हिंदी में नाम..."
}) {
  const [localHindi, setLocalHindi] = useState(hindiValue || '');
  const [isAutoMode, setIsAutoMode] = useState(true);
  const { t } = useLanguage();

  useEffect(() => {
    if (hindiValue && hindiValue !== localHindi) {
      setLocalHindi(hindiValue);
      setIsAutoMode(false);
    }
  }, [hindiValue]);

  useEffect(() => {
    if (isAutoMode && englishValue) {
      const auto = transliterateToHindi(englishValue);
      setLocalHindi(auto);
      if (onHindiChange) onHindiChange(auto);
    }
  }, [englishValue, isAutoMode, onHindiChange]);

  const handleHindiChange = (e) => {
    setIsAutoMode(false);
    setLocalHindi(e.target.value);
    if (onHindiChange) onHindiChange(e.target.value);
  };

  const resetToAuto = () => {
    setIsAutoMode(true);
    const auto = transliterateToHindi(englishValue);
    setLocalHindi(auto);
    if (onHindiChange) onHindiChange(auto);
  };

  return (
    <div className="space-y-3">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label || t('name')} (English) {required && <span className="text-red-500">*</span>}
        </label>
        <input
          type="text"
          value={englishValue}
          onChange={(e) => onEnglishChange(e.target.value)}
          placeholder={englishPlaceholder}
          className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-shadow"
          required={required}
          data-testid="name-english-input"
        />
      </div>
      <div>
        <div className="flex justify-between items-center mb-1">
          <label className="block text-sm font-medium text-gray-700">
            {label || t('name')} (हिंदी) 
            {isAutoMode && (
              <span className="ml-2 text-xs text-green-600 bg-green-50 px-2 py-0.5 rounded-full">
                Auto
              </span>
            )}
          </label>
          {!isAutoMode && (
            <button 
              type="button" 
              onClick={resetToAuto} 
              className="text-xs text-orange-600 hover:text-orange-700 hover:underline flex items-center gap-1"
            >
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
              Auto Generate
            </button>
          )}
        </div>
        <input
          type="text"
          value={localHindi}
          onChange={handleHindiChange}
          placeholder={hindiPlaceholder}
          className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-shadow"
          data-testid="name-hindi-input"
        />
        {isAutoMode && englishValue && (
          <p className="text-xs text-gray-500 mt-1">
            अंग्रेजी से स्वचालित रूप से बना | आप इसे संपादित कर सकते हैं
          </p>
        )}
      </div>
    </div>
  );
}

export default { LanguageProvider, LanguageToggle, LanguageToggleCompact, useLanguage, transliterateToHindi, AutoHindiNameInput };
